"use client";

import type { ReactNode } from "react";

import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import type { WithStylexArray } from "../../../types/withStyleXArray.types";
import { Button } from "../../_base/_core/Button/Button";

type AuthSubmitProps = WithStylexArray<{
  disabled: boolean;
  children: ReactNode;
}>;

export const AuthSubmitButton = ({
  disabled,
  children,
  styleXArray,
}: AuthSubmitProps) => {
  const isDesktop = useIsDesktopViewport();
  return (
    <Button
      type="submit"
      disabled={disabled}
      size="l"
      styleXArray={styleXArray}
      isFullWidth={!isDesktop}
    >
      {children}
    </Button>
  );
};
